module.exports = __webpack_public_path__ + "static/media/idontknow.4b8b59c5.png";